module.exports = __webpack_public_path__ + "static/media/309.60b58ee3.jpg";